import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.error};
    font-size: 1.2rem;
    margin: 12px 0 0 0;
  `};
`;
